import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What personal data does Pankaj Singh collect?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "We collect data such as name, email address, phone number, and project requirements when users fill out forms or contact us for services."
      }
    },
    {
      "@type": "Question",
      "name": "How is my personal information used?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Your information is used to understand your needs, provide services, respond to inquiries, and for internal record-keeping or invoicing purposes."
      }
    },
    {
      "@type": "Question",
      "name": "Do you share my data with third parties?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. We do not sell or share your personal data with third parties except when required for service delivery (e.g., domain registration, hosting setup), and only with your consent."
      }
    },
    {
      "@type": "Question",
      "name": "Is my data secure?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We follow best practices to ensure the security of your information, including SSL encryption and limited access controls. However, no system is 100% foolproof online."
      }
    },
    {
      "@type": "Question",
      "name": "Can I request to delete my personal data?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You can email us at info@pankj.com to request data deletion. We will comply as long as the data is not required for legal or service obligations."
      }
    },
    {
      "@type": "Question",
      "name": "Do you use cookies on your website?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. We may use cookies to enhance user experience, analyze traffic, and improve site performance. You can disable cookies in your browser settings."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>Privacy Policy – Website Designers In Gurgaon</title>
<meta name="description" content="At Pankaj Web Design, we value your privacy. Learn how we collect, use, and protect your personal data when you use our website design services in Gurgaon, Delhi, and Noida." />
<meta name="keywords" content="privacy policy, pankaj web designer, website designer in gurgaon, web design privacy terms, personal data protection, freelance web developer india, web design company in gurgaon, pankj.com privacy policy" />
<meta property="og:title" content="Privacy Policy – Website Designers in Gurgaon | Website Development Company in Gurgaon" />
<meta property="og:description" content="Read our privacy policy to understand how Pankaj Web Design collects, uses, and secures your personal information while offering website design services in Gurgaon, Delhi, and Noida." />
<meta property="og:site_name" content="Privacy Policy – Website Designers in Gurgaon | Website Development Company in Gurgaon" />
<meta property="og:url" content="https://www.pankj.com/privacy-policy" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Privacy Policy – Website Designers in Gurgaon | Website Development Company in Gurgaon" />
<meta name="twitter:description" content="Learn how we handle your personal data at Pankaj Web Design, a trusted freelance website designer in Gurgaon serving Delhi and Noida clients." />
<link rel="canonical" href="https://www.pankj.com/privacy-policy" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Privacy Policy</h1>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
        <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.webp" alt="best web designer in gurgaon" />
      </div>
      </div>
        </div>
      </div>
    </div> 
</div>
  </section>   

<main id="main">
<section id="pageContent" className="pageContent">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Privacy Policy</h2>
        </header>
        <div className="row">
          <div className="col-lg-12">
        <p><strong>Effective Date:</strong> July 12, 2025</p>
        <p><strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a></p>
        <p><strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a></p>
        <h2 className="text-xl font-semibold mt-6">1. Introduction</h2>
        <p>
          This Privacy Policy outlines how Pankaj Singh (“we”, “our”, or “us”) collects, uses, and protects your personal information when you interact with our website or services.
        </p>
        <h3 className="text-xl font-semibold mt-6">2. Information We Collect</h3>
        <ul className="list-disc list-inside">
          <li>Full name and contact details (email, phone number)</li>
          <li>Business or project-related information you provide</li>
          <li>Website analytics data (via Google Analytics, cookies, etc.)</li>
          <li>Browser and device information</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6">3. How We Use Your Information</h3>
        <p>Your data is used for the following purposes:</p>
        <ul className="list-disc list-inside">
          <li>To provide website design and development services</li>
          <li>To communicate about your project</li>
          <li>To process payments and generate invoices</li>
          <li>To improve website performance and usability</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6">4. Data Sharing and Disclosure</h3>
        <p>
          We do not sell, rent, or trade your personal data. Information may be shared with:
        </p>
        <ul className="list-disc list-inside">
          <li>Payment gateway providers</li>
          <li>Domain/hosting service partners (when needed for your project)</li>
          <li>Legal or regulatory authorities when required by law</li>
        </ul>

        <h3 className="text-xl font-semibold mt-6">5. Cookies & Tracking Technologies</h3>
        <p>
          We use cookies to enhance user experience and collect analytical data through tools like Google Analytics. You can disable cookies in your browser settings.
        </p>

        <h3 className="text-xl font-semibold mt-6">6. Data Retention</h3>
        <p>
          We retain client information for the duration of the project and up to 12 months after completion unless legally required to retain it longer.
        </p>

        <h3 className="text-xl font-semibold mt-6">7. Your Rights</h3>
        <p>
          You have the right to access, modify, or request deletion of your personal data by emailing us at <a href="mailto:info@pankj.com">info@pankj.com</a>.
        </p>

        <h3 className="text-xl font-semibold mt-6">8. Data Security</h3>
        <p>
          We follow best practices to protect your data including SSL encryption, secure payment gateways, and limited access controls.
        </p>

        <h3 className="text-xl font-semibold mt-6">9. External Links</h3>
        <p>
          Our website may contain links to third-party sites. We are not responsible for the privacy practices or content of those sites.
        </p>

        <h3 className="text-xl font-semibold mt-6">10. Policy Updates</h3>
        <p>
          This Privacy Policy may be updated periodically. All changes will be posted on this page with the effective date.
        </p>

        <h3 className="text-xl font-semibold mt-6">11. Contact Us</h3>
        <p>
          If you have questions regarding this policy, contact us at: <br />
          <strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a><br />
          <strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a>
        </p>

          </div>

        </div>
      </div>

    </section>    <Contact /> 
    </main>
    </>
  );
}
export default App1;
